import {Component, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {FieldConfig} from "../../../interfaces/field.interface";

@Component({
    selector: "app-radiobutton",
    template: `
        @if (hideMe != true && field.hideMe != true) {
          <span class="{{field.name}}-dynamic-class">
            <div style="display: flex;flex-direction: column;align-items: flex-start;justify-content: flex-start;gap: 10px;margin-left: 50px;margin-bottom: 10px;" class="demo-full-width" [formGroup]="group">
              <label style="display: block" style="position: relative; left: -30px; white-space: nowrap;" class="radio-label-padding">select {{field.label}}</label>
              <mat-radio-group [formControlName]="field.name">
                @if (field.skipFirst == true) {
                  @for (item of field.options | slice:1; track item) {
                    <mat-radio-button style="display:block; text-align: left" [value]="item">{{item}}
                    </mat-radio-button>
                  }
                } @else {
                  @for (item of field.options; track item) {
                    <mat-radio-button style="display:block; text-align: left" [value]="item">{{item}}
                    </mat-radio-button>
                  }
                }
              </mat-radio-group>
            </div>
          </span>
        }
        `,
    styles: []
})
export class RadiobuttonComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    public hideMe = false;

    constructor() {
    }

    ngOnInit() {
    }
}
